import anthologies from './anthologies';
import articles from './articles';
import auth from './auth';
import topics from './topics';
import user from './user';
import statistics from './statistics';

const online = {
	auth,
	user,
	articles,
	anthologies,
	topics,
	statistics,
};

export default online;
